import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

function LoadingSpinner({
    className, loading, size,
})
{
    if (loading)
    {
        return (
            <FontAwesomeIcon className={className} spin size={size} mask={['spin']} pulse icon={faSpinner} />
        );
    }

    return null;
}

LoadingSpinner.displayName = 'LoadingSpinner';

LoadingSpinner.defaultProps = {
    size: '1x',
};

LoadingSpinner.propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    size: PropTypes.any,
};

export default LoadingSpinner;
